import React from 'react';

import CoverageColgateList  from 'components/Tvendo/Sale/QuotaBPartner/Colgate/CoverageColgate/List.js';

export default function () {
  return <CoverageColgateList  />;
}